import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_builder/detection/')({
  beforeLoad: () => {
    throw redirect({ to: '/detection/scenarios' });
  },
});
